import React, { useState, useEffect } from "react"
import { links } from "../../components/data"
import { useDispatch, useSelector } from "react-redux"
import { subscribeNewsletter } from "../../store/SubScribe/SubScribeAction"
import { subscribeAction } from "../../store/SubScribe/SubScribeReducer"
import { toast } from "react-toastify"
import Icon from "@mdi/react"
import { mdiHeart } from "@mdi/js"

const Footer = () => {
  const [email, setEmail] = useState("")

  const { isSubmit, error, newsletter } = useSelector(
    (state) => state.subscribe
  )
  const dispatch = useDispatch()

  useEffect(() => {
    if (isSubmit) {
      toast.success(
        newsletter?.message || "Newsletter Subscribe Successfully",
        {
          position: "bottom-right",
          style: { fontSize: "12px" },
        }
      )
      setEmail("")
      dispatch(subscribeAction.clearSubmit())
    }
    if (error) {
      toast.error(newsletter?.message || "This email already exists!", {
        position: "bottom-right",
        style: { fontSize: "12px" },
      })
      dispatch(subscribeAction.clearError())
    }
  }, [dispatch, isSubmit, error, newsletter])

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(subscribeNewsletter({ email }))
  }

  return (
    <div className="footer">
      <div className="footer__upper">
        <div className="footer__column footer__column--logo">
          <a href="/" className="footer__logo-link">
            <img
              src="/images/Newlogo.webp"
              alt="Pulpit cab service logo - Premium taxi booking platform"
              className="footer__logo"
            />
          </a>
                    {/* <button className="downloadSection__button downloadSection__button--apple">
            <a
              className="downloadSection__link"
              href="https://apps.apple.com/in/app/pulpit-supermarket-of-rides/id6444613022"
              target="_blank"
              rel="noreferrer"
            >
              <svg className="downloadSection__icon" aria-hidden="true">
                <use href="/sprite.svg#icon-appleinc"></use>
              </svg>
              <div className="downloadSection__text">
                <span className="downloadSection__text-primary">
                  Download on the
                </span>
                <span className="downloadSection__text-secondary">
                  App Store
                </span>
              </div>
            </a>
          </button> */}
          <br />
          <div className="footer__heading-secondary">OFFICE HOURS</div>
          <div className="footer__text">Mon-Sat: 9:00 am to 7:00pm</div>
          <ul className="footer__social-list">
            <a href={links?.facebook} target="_blank" rel="noreferrer">
              <li className="footer__social-item">
                <svg className="footer__social-icon" aria-hidden="true">
                  <use href="/sprite.svg#icon-facebook"></use>
                </svg>
              </li>
            </a>
            <a href={links?.twitter} target="_blank" rel="noreferrer">
              <li className="footer__social-item">
                <svg className="footer__social-icon" aria-hidden="true">
                  <use href="/sprite.svg#icon-twitter"></use>
                </svg>
              </li>
            </a>
            <a href={links?.whatsapp} target="_blank" rel="noreferrer">
              <li className="footer__social-item">
                <svg className="footer__social-icon" aria-hidden="true">
                  <use href="/sprite.svg#icon-whatsapp"></use>
                </svg>
              </li>
            </a>
            <a href={links?.instagram} target="_blank" rel="noreferrer">
              <li className="footer__social-item">
                <svg className="footer__social-icon" aria-hidden="true">
                  <use href="/sprite.svg#icon-instagram"></use>
                </svg>
              </li>
            </a>
            <a href={links?.linkedin} target="_blank" rel="noreferrer">
              <li className="footer__social-item">
                <svg className="footer__social-icon" aria-hidden="true">
                  <use href="/sprite.svg#icon-linkedin"></use>
                </svg>
              </li>
            </a>
          </ul>
        </div>
        <div className="footer__column footer__column--links">
          <div className="footer__heading-primary">QUICK LINKS</div>
          <div className="flex gap-[3px] mb-[27px]">
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[40px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[10px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[5px]"></div>
          </div>
          <ul className="footer__links-list">
            <li className="footer__links-item">
              <a href="/about-us/" className="footer__page-link">
                About us
              </a>
            </li>
            <li className="footer__links-item">
              <a href="https://support.pulpitcabs.com" className="footer__page-link" target="_blank" rel="noreferrer">
                Support
              </a>
            </li>
            <li className="footer__links-item">
              <a href="/blogs/" className="footer__page-link">
                Blog
              </a>
            </li>
            <li className="footer__links-item">
              <a href="/corporate-cab-services/" className="footer__page-link">
                Corporate
              </a>
            </li>
            <li className="footer__links-item">
              <a href="/cab-driver-registration/" className="footer__page-link">
                Partner
              </a>
            </li>
            <li className="footer__links-item">
              <a href="/get-app/" className="footer__page-link">
                Get App
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__column footer__column--contact">
          <div className="footer__heading-primary mb-[10px]">
            CONTACT DETAILS
          </div>
          <div className="flex gap-[3px] mb-[27px]">
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[40px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[10px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[5px]"></div>
          </div>
          <ul className="footer__contact-list">
            <li className="footer__contact-item">
              <div className="footer__heading-secondary">PHONE NUMBER</div>
              <div className="footer__contact-box">
                <div className="footer__contact-iconbg">
                  <svg className="footer__contact-icon" aria-hidden="true">
                    <use href="/sprite.svg#icon-phone"></use>
                  </svg>
                </div>
                <a 
                  href={`tel:+91${links?.phone?.replace(/\s/g, '')}`}
                  className="footer__text footer__phone-link"
                  onClick={(e) => {
                    // Track click event if needed
                    console.log('Phone number clicked');
                  }}
                >
                  (+91) {links?.phone}
                </a>
              </div>
            </li>
            <li className="footer__contact-item">
              <div className="footer__heading-secondary">EMAIL ADDRESS</div>
              <div className="footer__contact-box">
                <div className="footer__contact-iconbg">
                  <svg className="footer__contact-icon" aria-hidden="true">
                    <use href="/sprite.svg#icon-email"></use>
                  </svg>
                </div>
                <a 
                  href={`mailto:${links?.email}`}
                  className="footer__text footer__email-link"
                  onClick={(e) => {
                    // Track click event if needed
                    console.log('Email address clicked');
                  }}
                >
                  {links?.email}
                </a>
              </div>
            </li>
            <li className="footer__contact-item">
              <div className="footer__heading-secondary">OFFICE LOCATION</div>
              <div className="footer__contact-box">
                <div className="footer__contact-iconbg">
                  <svg className="footer__contact-icon" aria-hidden="true">
                    <use href="/sprite.svg#icon-location"></use>
                  </svg>
                </div>
                <div className="footer__text">
                  305, CAPITOL ICON, <br></br>Sargasan, Gandhinagar,<br></br>{" "}
                  Gujarat 382421
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="footer__column footer__column--newsletter">
          <div className="footer__heading-primary">NEWSLETTER</div>
          <div className="flex gap-[3px] mb-[27px]">
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[40px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[10px]"></div>
            <div className="h-[1px] border-b-[2px] border-[#21A5A0] w-[5px]"></div>
          </div>
          <div className="footer__newsletter-text">
            Sign up to get the latest updates and news from PulpitCabs. Receive exclusive deals and offers directly in your inbox.
          </div>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email"
              className="input-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="input-submit-button !font-[500] footer__subscribe-button">
              SUBSCRIBE NOW
            </button>
          </form>
        </div>
      </div>
      <div className="footer__lower">
        <div className="footer__lower-text">
          Created with <Icon path={mdiHeart} size={0.9} className="inline-block" style={{ color: '#ff0000', verticalAlign: 'middle' }} /> by the Pulpit Team
        </div>
        <div className="footer__lower-links">
          <a href="/privacy_policy/" className="footer__lower-link">
            Privacy Policy
          </a>
          <a href="/terms_condition/" className="footer__lower-link">
            {" "}
            | Terms & Conditions
          </a>
          <a href="/refund-cancellation/" className="footer__lower-link">
            {" "}
            | Refund & Cancellation
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
